import React from "react";
import { PatientDiseaseContainer } from "../PatientDiseaseContainer";
import { DiseaseCluster } from "fe-common/hooks/sortFeaturesWithCrs";
import { DDClinicalReasoning } from "fe-common/graphql/dao";
import { crToQualifiedFeature } from "fe-common/logic";

//region [[ Styles ]]
//endregion [[ Styles ]]

//region [[ Props ]]
interface MiniDiseaseGraphNewProps {
  fWithCrs: DiseaseCluster;
  selectedCR: DDClinicalReasoning;
  changeTab?: (tabIndex: number) => void;
}
//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

const MiniDiseaseGraph = ({
  fWithCrs,
  selectedCR,
  changeTab,
}: MiniDiseaseGraphNewProps) => {
  const feature = selectedCR ? crToQualifiedFeature(selectedCR) : fWithCrs;
  return (
    <PatientDiseaseContainer
      fWithCrs={feature}
      isMiniView={true}
      changeTab={changeTab}
    />
  );
};

export default MiniDiseaseGraph;
